import React from 'react'
import { Card, Message, Grid } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import { connect } from 'react-redux';
import ResendDeletePlaybookInvitaion from '../../../lifecycleDesigner/drive/modals/ResendDeletePlaybookInvitaion'
import ViewUserCard from '../../Drive/modals/ViewUserCard'
import ImageAvater from '../../../../drive/Components/ImageAvater';
@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})


class UserCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            viewUserDetails: {},
            editSubOrgInviteDetail: {}
        }
        this.viewUserCardModal = this.viewUserCardModal.bind(this)
    }
    resendAndDeleteInvite(e, invite) {
        dispatch.lifeCycle.resendAndDeleteInviteModal(true);
        this.setState({ editSubOrgInviteDetail: invite })
    }
    viewUserCardModal(e, user) {
        dispatch.initiatives.viewUserModalOpen(true);
        this.setState({ viewUserDetails: user })
    }

    render() {
        let suborgdata;
        if (this.props.suborgDetails && this.props.suborgDetails.data && this.props.suborgDetails.data.length !== 0) {
            suborgdata = this.props.suborgDetails.data[0];
        }

        return (
            <Grid>
                <Card.Group>
                    {suborgdata && suborgdata.members && suborgdata.members.length !== 0 ? suborgdata.members.map((item, index) => {
                        return <Card className="contributorCard " style={{ "cursor": 'pointer' }} key={index}>
                            <Card.Content onClick={(e) => this.viewUserCardModal(e, item)}>
                                <ImageAvater user={item.accountUserId} />
                                <Card.Header>{item.accountUserId.firstName} {item.accountUserId.lastName}</Card.Header>
                                <Card.Meta>{item.role}</Card.Meta>
                            </Card.Content>
                        </Card>
                    }) : <Message
                            style={{ 'paddingTop': '25px' }}
                            className="w_100"
                            color='teal'
                            header='No users to display.'
                        />}
                    {this.props.subOrgInvitaions && this.props.subOrgInvitaions.length ?
                        this.props.subOrgInvitaions.map(function (invite, index) {
                            return (
                                <Card className="contributorCard playbookInviteBg" style={{ "cursor": 'pointer' }} key={index} >
                                    <Card.Content onClick={(e) => this.resendAndDeleteInvite(e, invite)} style={{ padding: "0 10px" }}>
                                        <ImageAvater user={invite} />
                                        <Card.Header>{invite.firstName + ' ' + invite.lastName}</Card.Header>
                                        <Card.Meta>{invite.role + " (Invited)"}</Card.Meta>
                                    </Card.Content>
                                </Card>
                            );
                        }, this)
                        : ''}

                </Card.Group>
                {this.props.isViewUserModalOpen ?
                    <ViewUserCard isViewUserModalOpen={this.props.isViewUserModalOpen}
                        viewUserDetails={this.state.viewUserDetails}
                        user={this.props.user}
                        suborgdata={suborgdata}
                        selectedOrganisation={
                            this.props.selectedOrganisation
                        }
                        organizationsMap={this.props.organizationsMap}
                    /> : ''}

                {this.props.isPlaybookInvitationModalOpen ?
                    <ResendDeletePlaybookInvitaion isPlaybookInvitationModalOpen={this.props.isPlaybookInvitationModalOpen}
                        editPlaybookInviteDetail={this.state.editSubOrgInviteDetail}
                        selectedOrganisation={this.props.selectedOrganisation}
                        teamName={suborgdata.name}
                        user={this.props.user}
                    /> : ''}
            </Grid>

        )
    }
}

function mapStateToProps(state) {

    return {
        suborgDetails: state.initiatives.suborgDetails,
        subOrgInvitaions: state.initiatives.subOrgInvitaions,
        isPlaybookInvitationModalOpen: state.lifeCycle.isPlaybookInvitationModalOpen,
        selectedOrganisation: state.app.selectedOrganisation,
        isViewUserModalOpen: state.initiatives.isViewUserModalOpen
    };
}

const connectedUserCard = connect(mapStateToProps)(UserCard);

export default connectedUserCard